<template>
    <div class="sv">
        <h1 class="sv-title">{{title}}</h1>
        <div class="sv-v"></div>
        <div class="sv-box">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name:'SV',
    props:{
        title: {
            type: String,
            default: 'TITLE.未知标题'
        }
    }
}
</script>

<style>
.sv-box::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 3px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.sv-box::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  background: rgba(255, 0, 0, .1);
}
.sv-box::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  background: rgba(255, 255, 255, 0);
}
.sv{
    position: absolute;
    top: 8vh;
    left: 0;
    right: 0;
    bottom: 8vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.sv-title{
    user-select:none;
    margin: 1rem 0;
}
.sv-box{
    width: 100%;
    max-height: 100%;
    padding: 0 10px;
    margin-bottom: 41px;
    color: #dc9495;
    overflow: auto;
}
.sv-v{
    width: 100%;
    height: 2px;
    background-color: rgba(58, 3, 3, 0.05);
}
</style>